export const ModifyVideoReviewDecision = {
  name: "video-review-decision-modify",
  component: "MainPanel",
  layout: "main-panel x-large",
  mode: "visible",
  text: "decision",
  showOn: [
    {
      state: "editState",
      operator: "is",
      value: "video-review-decision-modify",
    }],
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "video-review-decision-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        optionName: "decision",
        layout: "type-button",
        prefix: "decision",
        children: ["upheld", "overturned"],
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
